import React from "react";
import { Row, Col, Typography } from "antd";
const { Text } = Typography;
export default function FileCard({
  fileIcon,
  fileName,
  secondaryAction,
  fileUrl,
  actionIcon,
  offset
}) {
   
  return (
    <Row className="sz-file-card">
      <Col span={4}>{fileIcon}</Col>
      <Col span={14} offset={2} >
        <Row>
          <Col>
          <Text style={{ maxWidth: '100%' }} ellipsis={true}>
      {fileName}
    </Text>
         
          </Col>
        </Row>
        <Row>
          <Col>{secondaryAction}</Col>
        </Row>
      </Col>
      <Col span={2} push={2}>
        {actionIcon}
      </Col>
    </Row>
  );
}
